<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 법정교육 이수계획 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 법정교육 이수계획</h5>
          <vs-col v-if="!board.readonly" class="w-auto ml-auto">
            <vs-button class="mr-4" color="secondary" @click="handleClickPush('completionPlan')">항목추가</vs-button>
            <vs-button class="mr-4" color="secondary" type="border" @click="handleClickRemove('completionPlan')">선택삭제</vs-button>
          </vs-col>
        </vs-col>
      </vs-row>
      <div class="mt-4 style-table" >
        <div class="style-table-head">
          <div class="style-table-item" @click.stop="changePlanAllCheck"><vs-checkbox :value="allCheck"/></div>
          <div class="style-table-item">No.</div>
          <div class="style-table-item">법정교육명</div>
          <div class="style-table-item">교육대상</div>
          <div class="style-table-item">이수대상(명)</div>
          <div class="style-table-item">주기</div>
          <div class="style-table-item">교육시기</div>
          <div class="style-table-item">교육기관</div>
          <div class="style-table-item">교육 이수증</div>
        </div>

        <div v-for="(item, index) in form.completionPlan"
             class="style-table-body">
          <!-- check -->
          <div class="style-table-item">
            <span v-if="isPrint" class="print-checkbox ml-2"><i><feather-icon v-if="item.is_checked" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
            <vs-checkbox v-else v-model="item.is_checked"/>
          </div>

          <!-- no -->
          <div class="style-table-item">
            <p>{{ index+1 }}</p>
          </div>

          <!-- 법정교육명 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.법정교육명 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.법정교육명" class="w-full flex-1" />
          </div>

          <!-- 교육대상 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.교육대상 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.교육대상" class="w-full flex-1" />
          </div>

          <!-- 이수대상 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.이수대상 }}</p>
            <div v-else class="w-full" style="display: grid; grid-template-columns: 1fr auto; align-items: center;">
              <ml-input :readonly="board.readonly" class="w-full" type="number" v-model="item.이수대상" />
              <span class="ml-2">명</span>
            </div>
          </div>

          <!-- 주기 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.주기 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.주기" class="w-full flex-1" />
          </div>

          <!-- 교육시기 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.교육시기_시작일 }} ~ {{ item.교육시기_종료일}}</p>
            <div v-else class="w-full" style="display: grid; grid-template-columns: 1fr auto 1fr; align-items: center;">
              <date-selector v-model="item.교육시기_시작일"/>
              <span class="mx-2">~</span>
              <date-selector v-model="item.교육시기_종료일"/>
            </div>
          </div>

          <!-- 교육기관 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.교육기관 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="item.교육기관" class="w-full flex-1" />
          </div>

          <!-- 교육 이수증 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.교육이수증 }}</p>
            <file-uploader v-else v-model="item.교육이수증"/>
          </div>


        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploader from '@/components/FileUploader.vue'

export default {
  components: {
    FileUploader,
    DateSelector,
    FileUploadModule,
    TableInspectMerge,
    FieldSelectModule,
    PhotoUploadGridModule,
    DisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    allCheck () {
      let isCheck = this.form.completionPlan.length > 0
      for (const item of this.form.completionPlan) {
        if (!item.is_checked) {
          isCheck = false
          break;
        }
      }
      return isCheck;
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        completionPlan: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleClickPush (form_key) {
      this.form[form_key].push({
        is_checked: '',
        no: '',
        법정교육명: '',
        교육대상: '',
        이수대상: '',
        주기: '',
        교육시기_시작일: '',
        교육시기_종료일: '',
        교육기관: '',
        교육이수증: {}
      })
    },
    handleClickRemove (form_key) {
      for (let i = 0; i < this.form[form_key].length; i++) {
        if (this.form[form_key][i].is_checked) {
          this.form[form_key].remove(this.form[form_key][i])
          i = -1
        }
      }
    },

    changePlanAllCheck () {
      const all = !this.allCheck
      for (const data of this.form.completionPlan) {
        data.is_checked = all
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.sign-module::v-deep {
  justify-content: normal !important;
  .sign-field {
    flex: 1;
    max-width: none;
  }
}
</style>


<!-- table -->
<style scoped lang="scss">
.style-table {
  border-left:1px solid #CDCDCD; border-top:1px solid #CDCDCD;
}
.style-table-item {
  padding: 0.5rem;
  display: flex; justify-content: center; align-items: center; border-right: 1px solid #CDCDCD; border-bottom: 1px solid #CDCDCD;
}
.style-table-head,
.style-table-body {
  display: grid; grid-template-columns: 40px 65px 189fr 189fr 150fr 150fr 400fr 189fr 189fr;
}
.style-table-head {
  .style-table-item {
    height: 50px;
    background-color: #f9f9f9;
  }
}
</style>
